export const SEARCH_ALL_INSTRUCTOR = 'SEARCH_ALL_INSTRUCTOR';
export const SEARCH_ALL_ITEMS = 'SEARCH_ALL_ITEMS';
export const SEARCH_ITEMS = 'SEARCH_ITEMS';
